import { getMatchedPath } from '@/routing/getMatchedPath';
import { Location } from 'react-router-dom';

const isCurrentPath = (path: string, location: Location): boolean => {
  return path === getMatchedPath(location);
};

type PathValue = string | PathObject | HrefObject;

interface PathObject {
  path: string;
  children?: PathValue[];
}

interface HrefObject {
  href: string;
  children?: PathValue[];
}

function extractHref(path: PathValue): string | null {
  if (typeof path === 'string') return path;
  if ('path' in path) return path.path;
  if ('href' in path) return path.href;
  return null;
}

function getChildren(path: PathValue): PathValue[] | undefined {
  if (typeof path === 'object' && 'children' in path) {
    return path.children;
  }
  return;
}

interface Options {
  includeSelf: boolean;
  recursive: boolean;
}

const defaultOptions: Options = { includeSelf: true, recursive: true };

export function isPathActive(
  path: PathValue,
  location: Location,
  options: Partial<Options> = defaultOptions,
): boolean {
  const { includeSelf = true, recursive = true } = options;

  if (includeSelf) {
    const href = extractHref(path);
    if (href && isCurrentPath(href, location)) {
      return true;
    }
  }

  const children = getChildren(path);

  if (!children?.length) {
    return false;
  }

  return children.some((child) =>
    recursive ? isPathActive(child, location, options) : extractHref(child) === location.pathname,
  );
}
